import { EntityVm } from '../core/entity.vm';
import { IsString, IsEnum } from 'class-validator';

export enum OrderPickingStatus {
    CANCELED = 'CANCELED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMMITTED = 'COMMITTED',
    DOCUMENT_CREATION_FAIL = 'DOCUMENT_CREATION_FAIL',
    DOCUMENT_CREATION_SUCCESS = 'DOCUMENT_CREATION_SUCCESS',
}

export class PickingVm extends EntityVm {
    @IsString()
    tenant: string;

    @IsString()
    warehouseId: string;

    @IsString()
    orderId: string;

    @IsString()
    pickerName: string;

    @IsString()
    integrationError?: string;

    @IsEnum(OrderPickingStatus)
    status: OrderPickingStatus;
}
